import { LoadingButton } from "@mui/lab";
import { Button, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import IResponse from "../../interfaces/response";
import { useNavigate } from "react-router-dom";
import {z} from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const schema = z.object({
    login: z.string().min(3),
    password: z.string().min(8),
});

type FormFields = z.infer<typeof schema>

export default function Login() {
    const { t } = useTranslation();
    const {register, handleSubmit, formState: {errors, isSubmitting}} = useForm<FormFields>({resolver: zodResolver(schema)});
    const navigate = useNavigate();
    const handleLogin: SubmitHandler<FormFields> = async (data) => {
        const res = await axios<IResponse<{token: string}>>({
            url: "/users/login",
            method: 'POST',
            data
        })
        if (res.data.success) {
            localStorage.setItem('token', res.data.data.token);
            axios.defaults.headers['Authorization'] = `Bearer ${res.data.data.token}`;
            navigate('/');
        }
    }
    return <form className="flex flex-col items-center" onSubmit={handleSubmit(handleLogin)}>
        <div className="flex flex-row gap-3 py-2 border-b border-solid border-secondary-main mb-14">
            <img src='/logo.svg' alt='logo' />
            <Typography className="font-bold text-primary-main text-2xl">{t('app_name')}</Typography>
        </div>
        <Typography className="font-medium text-primary-main text-2xl mb-4 text-center">{t('welcome')}</Typography>
        <Typography className="text-text-secondary mb-6 text-center">{t('login_desc')}</Typography>
        <TextField {...register('login')} error={!!errors.login} helperText={errors.login?.message} className="w-full mb-6" label={t('username')} />
        <TextField {...register('password')} error={!!errors.password} helperText={errors.password?.message} className="w-full mb-3" type='password' label={t('password')} />
        <div className="flex flex-row justify-between w-full mb-6">
            <FormControlLabel control={<Checkbox defaultChecked />} label={t('remember_me')} />
            <Button color="secondary">{t('forget_password')}</Button>
        </div>
        <LoadingButton loading={isSubmitting} type="submit" size="large" variant="contained" className="w-full mb-4">{t('enter')}</LoadingButton>
        <div className="flex flex-row items-center gap-1">
            <Typography className="text-text-secondary">{t('do_you_have_account')}</Typography>
            <Button color="secondary">{t('create_account')}</Button>
        </div>
    </form>
}